import { render, staticRenderFns } from "./RatingConfiguratorPage.vue?vue&type=template&id=4583b6ed&"
import script from "./RatingConfiguratorPage.vue?vue&type=script&lang=js&"
export * from "./RatingConfiguratorPage.vue?vue&type=script&lang=js&"
import style0 from "./RatingConfiguratorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VFlex,VLayout,VSnackbar,VTab,VTabItem,VTabs})
